import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { toHex } from "@smithy/util-hex-encoding";
import { toUint8Array } from "@smithy/util-utf8";
import { KEY_TYPE_IDENTIFIER, MAX_CACHE_SIZE } from "./constants";
var signingKeyCache = {};
var cacheQueue = [];
export var createScope = function createScope(shortDate, region, service) {
  return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat(KEY_TYPE_IDENTIFIER);
};
export var getSigningKey = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sha256Constructor, credentials, shortDate, region, service) {
    var credsHash, cacheKey, key, _i, _arr, signable;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
          case 2:
            credsHash = _context.sent;
            cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat(toHex(credsHash), ":").concat(credentials.sessionToken);
            if (!(cacheKey in signingKeyCache)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", signingKeyCache[cacheKey]);
          case 6:
            cacheQueue.push(cacheKey);
            while (cacheQueue.length > MAX_CACHE_SIZE) {
              delete signingKeyCache[cacheQueue.shift()];
            }
            key = "AWS4".concat(credentials.secretAccessKey);
            _i = 0, _arr = [shortDate, region, service, KEY_TYPE_IDENTIFIER];
          case 10:
            if (!(_i < _arr.length)) {
              _context.next = 18;
              break;
            }
            signable = _arr[_i];
            _context.next = 14;
            return hmac(sha256Constructor, key, signable);
          case 14:
            key = _context.sent;
          case 15:
            _i++;
            _context.next = 10;
            break;
          case 18:
            return _context.abrupt("return", signingKeyCache[cacheKey] = key);
          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getSigningKey(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export var clearCredentialCache = function clearCredentialCache() {
  cacheQueue.length = 0;
  Object.keys(signingKeyCache).forEach(function (cacheKey) {
    delete signingKeyCache[cacheKey];
  });
};
var hmac = function hmac(ctor, secret, data) {
  var hash = new ctor(secret);
  hash.update(toUint8Array(data));
  return hash.digest();
};